import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ActivateService} from './service/activate.service';
import {mergeMap} from 'rxjs/operators';
import {LoginDialogComponent} from '../navigation-bar/login-dialog/login-dialog.component';
import {MatDialog} from '@angular/material/dialog';

@Component({
  selector: 'app-activate',
  templateUrl: './activate.component.html',
  styleUrls: ['./activate.component.css']
})
export class ActivateComponent implements OnInit {
  error = false;
  success = false;

  message = '';

  constructor(private route: ActivatedRoute, private activateService: ActivateService, private router: Router, public dialog: MatDialog) { }

  ngOnInit(): void {
    this.route.queryParams.pipe(mergeMap(params => this.activateService.get(params.key))).subscribe(
      () => {this.message = 'Registration completed successfully!'; this.success = true; },
      () => {this.message = 'Registration failed! Contact an administrator!'; this.error = true; }
    );
  }

  onSignIn(): void {
    this.router.navigateByUrl('/home');
    this.openLoginDialog();
  }

  openLoginDialog(): void {
    const dialogRef = this.dialog.open(LoginDialogComponent);

    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }

}
